import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import image_cars from "../../../../../project_images/cars-sm.webp";
import "../Projects.scss";

const projectCars = () => {
  return (
    <div className="App__projects-card">
      <Card className="App__projects-card-element">
        <Card.Img
          className="lazy"
          data-mdb-lazy-src={image_cars}
          variant="top"
          src={image_cars}
          alt="project image"
        />
        <Card.Body className="App__project-card-body">
          <Card.Title>Object Enumerator</Card.Title>
          <Card.Text>
            A program that identifies cars and counts them as they cross a
            camera's field of view. This project uses Tensorflow.js and was my
            first attempt at using computer vision in any application.
          </Card.Text>
          <div className="App__card-btn-wrapper">
            <Button
              href="https://github.com/mattwaelder/computer_vision/blob/readme/README.md"
              target="_blank"
              variant="light"
              className="App__project-card-btn"
            >
              Read Me
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default projectCars;
